import CircularProgress from '@mui/material/CircularProgress';
import React, { type FC } from 'react';
import LogoDigidom from '../../../Assets/Images/logo.png';

import { styled } from '@mui/material/styles';

const StyledContainer = styled('div')(() => ({
  top: 'calc( 50vh - 110px )',
  left: 'calc( 50vw - 110px )',
  position: 'fixed',
  zIndex: 30,
  width: 220,
  height: 220,
}));

const StyledImageLogo = styled('img')(() => ({
  position: 'absolute',
  width: 200,
  marginTop: -6,
  animationName: 'allAnimation',
  animationDuration: '1.5s',
  animationIterationCount: 'infinite',
}));

const StyledDivChild = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: '100%',
  position: 'relative',
}));

const StyledCircleProgress = styled(CircularProgress)(() => ({
  position: 'absolute',
}));

const LoadingContent: FC = () => {
  return (
    <StyledContainer>
      <StyledDivChild>
        <StyledCircleProgress thickness={0.6} size={220} color="primary" />
        <StyledImageLogo src={LogoDigidom} alt="" />
      </StyledDivChild>
    </StyledContainer>
  );
};

export default LoadingContent;
